<template>
  <div class="event-popup-category-header">
    <div class="event-popup-category-header__row">
      <ContactPageIcon class="event-popup-category-header__icon" />
      {{ eventCategoryText }}
    </div>
    <div v-if="online" class="event-popup-category-header__row">
      <PublicIcon class="event-popup-category-header__icon" />
      オンライン
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType, computed } from '@vue/composition-api';
import { EventCategory } from 'oc2api/popup';
import { eventCategoryToText } from 'utils/event';
import ContactPageIcon from 'images/contact_page.svg';
import PublicIcon from 'images/public.svg';

export default defineComponent({
  name: 'EventPopupCategoryHeader',
  components: {
    ContactPageIcon,
    PublicIcon,
  },
  props: {
    category: {
      type: String as PropType<EventCategory>,
      required: true,
    },
    online: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    const eventCategoryText = computed(() => eventCategoryToText(props.category));

    return {
      eventCategoryText,
    };
  },
});
</script>

<style lang="scss" scoped>
@import 'stylesheets/mixins';
@import 'stylesheets/variables';

.event-popup-category-header {
  margin-top: 16px;
  padding: 8px 0 8px 17px;
  border-left: 4px solid $oc-black;
  font-weight: 300;
  font-size: 14px;
  line-height: 172%;
  letter-spacing: 0.02em;
  color: $oc-black;
}

.event-popup-category-header__row {
  display: flex;
  align-items: center;
}

.event-popup-category-header__icon {
  flex: none;
  height: 15px;
  margin-right: 9px;
}
</style>
